import * as React from "react"
import {Link} from "gatsby"
import {} from "./footer.css"
import Contact from "./contact/contact";
import Credits from "./credits/credits";

const Footer = () => (
    <footer className={`container`} id={`contact`}>
        <Contact/>
        <Credits/>
    </footer>
)

export default Footer